/* @author z241843- Viswa
 * payment alert notifications 
 */

(function () {
    'use strict';

    angular.module('cvsApp').directive('paymentsInlineToaster', inlineToasterDirective);

    function inlineToasterDirective() {

        var directive = {
            restrict: 'E',
            templateUrl: '../payments/app/components/inlineToaster/inlineToaster.template.html',
            controller: ['$scope', '$anchorScroll', 'cvsAppData', inlineToasterController],
            controllerAs: 'inlineToaster',
            scope: {
                type: '@',
                icon: '@',
                heading: '@',
                message: '@',
                refid: '@',
                dismissfunction: '&',
                ctatext: '@',
                ctalink: '@',
                contactlink: '@',
                ctafunction: '&',
                headingAltText: '@',    
                errors: '=',
                showclosebtn: '@',
                config: '=',
                blockid: '@'
            },
            bindToController: true
        };

        return directive;

        function inlineToasterController($scope, $anchorScroll, CAD) {


            var vm = this;
            this.$onInit = function () {
                vm.hideAlert = false;
                vm.iconClass = '';
                vm.containerClass = '';
                determineAlertClasses();
                determineIconType();
            }

            var inlineAlertTypes = {
                'error': {
                    'iconClass': 'inline-toaster--error--icon',
                    'containerClass': 'inline-toaster--error'
                },

                'success': {
                    'iconClass': 'inline-toaster--success--icon',
                    'containerClass': 'inline-toaster--success'
                },

                'warning': {
                    'iconClass': 'inline-toaster--warning--icon',
                    'containerClass': 'inline-toaster--warning'
                },

                'info': {
                    'iconClass': 'inline-toaster--info--icon',
                    'containerClass': 'inline-toaster--info'
                }
            };
            var determineIconType = function () {

                if (vm.type === 'error') {
                    vm.iconAltText = "Error";
                }

                if (vm.type === 'success') {
                    vm.iconAltText = "Success";
                }

                if (vm.type === 'warning') {
                    vm.iconAltText = "Warning";
                }

                if (vm.type === 'info') {
                    vm.iconAltText = "Information";
                }

            };
            vm.dismissAlert = function () {
                vm.hideAlert = true;
                vm.dismissfunction();
            };

            vm.ctaClick = function () {
                vm.ctafunction();
            }


            $scope.isFEPClient = false;

            $scope.contactUs = function () {
                var getBrandingInfoObj = CAD.getBrandingInfos();
                if (getBrandingInfoObj != "" && getBrandingInfoObj != undefined){
                    if (getBrandingInfoObj[0].clientInfo.clientName == 'FEP') {
                    $scope.isFEPClient = true;
                    }
                }
                cvsUtility.checkIfFepClient($scope.isFEPClient);
            };

            var determineAlertClasses = function () {

                var alertType = inlineAlertTypes[vm.type];

                if (typeof (alertType) !== 'undefined') {

                    vm.iconClass = alertType.iconClass;
                    vm.containerClass = alertType.containerClass;

                }

            };

            // determineAlertClasses();
            // determineIconType();
        }

    }

})();